module.exports = __webpack_public_path__ + "img/webdatarocks-icons.e403c1a0.svg";